module.exports = __webpack_public_path__ + "static/media/cave_marker_dark_blue.f9269453.svg";